import { jsx as _jsx } from "react/jsx-runtime";
import { Notice } from '@tencent/cms-design-component';
import cookie from 'js-cookie';
import { TRANS_TIP_CLOSED } from 'portal-common/constants';
import React, { useEffect, useState } from 'react';
import ls from '../OldRender/utils/localStorage';
var LS_NOTICE_KEY = 'INTL_NOTICE_TIP';
var LS_NOTICE_SWITCH_KEY = 'INTL_NOTICE_SWITCH';
var VISIBLE = 1;
var HIDDEN = 2;
var NoticeComponent = function(param) {
    var _transTip = param.transTip, transTip = _transTip === void 0 ? false : _transTip, noticeDesc = param.noticeDesc, noticeType = param.noticeType, longTimeMode = param.longTimeMode, _linkData = param.linkData, linkData = _linkData === void 0 ? {} : _linkData, _noFix = param.noFix, noFix = _noFix === void 0 ? false : _noFix;
    var ref = useState(-1), visible = ref[0], setVisible = ref[1];
    var ref1 = useState(null), prevMode = ref1[0], setPrevMode = ref1[1];
    useEffect(function() {
        if (transTip) {
            // transTip 模式：通过 cookie 控制，关闭浏览器后 cookie 过期（session cookie）
            var closed = cookie.get(TRANS_TIP_CLOSED) === '1';
            setVisible(closed ? HIDDEN : VISIBLE);
            return;
        }
        // 普通模式：通过 localStorage 控制
        var savedVisible = ls.get(LS_NOTICE_KEY);
        var savedMode = ls.get(LS_NOTICE_SWITCH_KEY);
        setVisible(savedVisible || VISIBLE);
        setPrevMode(savedMode);
    }, []);
    // 初始化未完成时不渲染
    if (visible < 0) {
        return null;
    }
    // 已关闭则不展示
    if (visible === HIDDEN) {
        return null;
    }
    // 普通模式：处理模式切换逻辑
    if (!transTip) {
        if (longTimeMode !== prevMode) {
            // 模式切换，重置为展示
            ls.set(LS_NOTICE_KEY, VISIBLE);
        } else if (!longTimeMode && visible === HIDDEN) {
            // 一次性模式且已关闭
            return null;
        }
        ls.set(LS_NOTICE_SWITCH_KEY, longTimeMode);
    }
    var handleClose = function() {
        if (transTip) {
            try {
                cookie.set(TRANS_TIP_CLOSED, '1', {
                    path: '/',
                    sameSite: 'Lax'
                });
            } catch (e) {
            // ignore
            }
            setVisible(HIDDEN);
        } else if (!longTimeMode) {
        // ls.set(LS_NOTICE_KEY, HIDDEN);
        }
    };
    return(/*#__PURE__*/ _jsx("div", {
        id: "langnotice",
        children: /*#__PURE__*/ _jsx(Notice, {
            noFix: noFix,
            txt: noticeDesc,
            type: noticeType,
            linkData: linkData,
            onNoticeClick: handleClose
        })
    }));
};
export default NoticeComponent;
